import { render, staticRenderFns } from "./insights-no-results.component.vue?vue&type=template&id=1db2c065&scoped=true"
import script from "./insights-no-results.component.vue?vue&type=script&lang=ts"
export * from "./insights-no-results.component.vue?vue&type=script&lang=ts"
import style0 from "./insights-no-results.component.vue?vue&type=style&index=0&id=1db2c065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2c065",
  null
  
)

export default component.exports